import ReportIcon from "@mui/icons-material/Report";
import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import Collapse from "@mui/material/Collapse";
import TokenService from "../service/TokenService";

function MenuReports({ handleNavigation }) {
  const [openRpt, setOpenRpt] = useState(false);
  const handleClickRpt = () => {
    setOpenRpt(!openRpt);
  };
  const tokenServiceDetails = TokenService.getUserDetails();
  const urights = tokenServiceDetails?.userrights;
  return (
    <List sx={{ bgcolor: "background.paper" }} component="nav">
      <ListItemButton onClick={handleClickRpt}>
        <ListItemIcon>
          <ReportIcon style={{ color: "black" }} />
        </ListItemIcon>
        <ListItemText primary="Reports" sx={{ color: "black" }} />
        {openRpt ? (
          <ExpandLess style={{ color: "red" }} />
        ) : (
          <ExpandMore style={{ color: "black" }} />
        )}
      </ListItemButton>
      <Collapse in={openRpt} timeout="auto" unmountOnExit>
        <List component="div" disablePadding sx={{ color: "black" }}>



          <ListItemButton
            sx={{ pl: 4 }}
            /// onClick={() => navigate("poreport")}
            onClick={() => handleNavigation("adminreports")}
          >
            <ListItemIcon>
              <StarBorder style={{ color: "black" }} />
            </ListItemIcon>
            <ListItemText primary="Admin Report" />
          </ListItemButton>


          {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("auditreports")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Audit Report" />
            </ListItemButton>
  
            
          )}
  





        </List>
      </Collapse>
    </List>
  );
}

export default MenuReports;
